<script setup lang="ts">
import type { Portfolio } from "~/typings/portfolio";
import ProjectList from "./ProjectList.vue";

defineProps<{
  experiences: Portfolio.Experience[];
}>();
</script>

<template>
  <div class="flex justify-between items-start">
    <div class="mb-8">
      <UiTitle
        level="3"
        class="text-3xl lg:text-6xl font-semibold leading-tight mb-4"
      >
        Recent Projects
      </UiTitle>
      <UiParagraph class="text-lg mb-4">
        Here's a quick look at some of my recent projects
      </UiParagraph>
    </div>
    <!-- Download Resume Button - Desktop Only -->
    <div class="hidden lg:flex flex-col items-end mb-8 gap-3">
      <UiRecruiterCta />
      <UiDownloadResume />
    </div>
  </div>
  <ProjectList :experiences="experiences" />
</template>
